export enum Hp6TableActionsType {
  SORT = 'SORT',
  SORT_CLEAR = 'SORT_CLEAR',
  FILTER_ADD = 'FILTER_ADD',
  FILTER_REMOVE = 'FILTER_REMOVE',
  FILTER_REPLACE = 'FILTER_REPLACE',
  FILTER_CLEAR = 'FILTER_CLEAR',
}

interface Hp6TableActionEventDetailType {
  action: Hp6TableActionsType;
  columnIndex: number;
  value?: string;
}

export class Hp6TableActionEventDetail {
  /**
   * The original event
   */
  originalEvent: Event;

  /**
   * Detail of this action
   */
  detail: Hp6TableActionEventDetailType;

  constructor(event: Event, detail: Hp6TableActionEventDetailType) {
    this.originalEvent = event;
    this.detail = detail;
  }
}
